import { render, staticRenderFns } from "./Waitting.vue?vue&type=template&id=2b33d54a&"
import script from "./Waitting.vue?vue&type=script&lang=js&"
export * from "./Waitting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports